import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { setColor, selectMaterial, setMaterial, setAddon, selectAddon, selectAddon2 } from '../store/byoSlice'

const ProductTile = ({ data }) => {
  const { step, color, material, materialSelected, addons, addonSeleted, addon2Seleted } = useSelector((state) => state.byo)
  const dispatch = useDispatch()
  let setMethod = null
  let selectMethod = null
  let optionIndex = null
  let optionImage = null
  let activeProduct = null
  let activeVariant = null
  let displayName = null
  let listPrice = null
  switch (step) {
    case 1:
      optionIndex = color
      optionImage = data.option.option_image
      setMethod = selectMethod = setColor
      displayName = data.option.display_name
      listPrice = data.option.list_price
      break;
    case 2:
      optionIndex = materialSelected
      optionImage = data.option.option_image
      selectMethod = setMaterial
      setMethod = setMaterial
      displayName = data.option.display_name
      listPrice = data.option.list_price
      break;
    case 3:
      activeProduct = data.data.addons.filter((addon) => addon.product.id === data.productId).length > 0 ? data.data.addons.filter((addon) => addon.product.id === data.productId)[0] : null
      activeVariant = activeProduct ? (activeProduct.variants.filter((variant) => variant.data.id === data.variantId).length > 0 ? activeProduct.variants.filter((variant) => variant.data.id === data.variantId)[0] : null) : null
      optionImage = activeVariant && activeVariant.data.featured_image ? activeVariant.data.featured_image.src : ((activeProduct && activeProduct.product.featured_image) ? activeProduct.product.featured_image : null)
      displayName = activeVariant ? activeVariant.data.name : null
      listPrice = activeVariant ? activeVariant.data.price / 100.0 : null
      selectMethod = window.innerWidth > 1023 ? selectAddon : setAddon
      setMethod = setAddon
      break;
    case 4:
      activeProduct = data.data.addons2.filter((addon) => addon.product.id === data.productId).length > 0 ? data.data.addons2.filter((addon) => addon.product.id === data.productId)[0] : null
      activeVariant = activeProduct ? (activeProduct.variants.filter((variant) => variant.data.id === data.variantId).length > 0 ? activeProduct.variants.filter((variant) => variant.data.id === data.variantId)[0] : null) : null
      optionImage = activeVariant && activeVariant.data.featured_image ? activeVariant.data.featured_image.src : ((activeProduct && activeProduct.product.featured_image) ? activeProduct.product.featured_image : null)
      displayName = activeVariant ? activeVariant.data.name : null
      listPrice = activeVariant ? activeVariant.data.price / 100.0 : null
      selectMethod = window.innerWidth > 1023 ? selectAddon2 : setAddon
      setMethod = setAddon
      break;
    default:
      break;
  }

  window.addEventListener('resize', () => {
    switch (step) {
      case 2:
        selectMethod = window.innerWidth > 1023 ? selectMaterial : setMaterial
        break;
      case 3:
        selectMethod = window.innerWidth > 1023 ? selectAddon : setAddon
        break;
      case 4:
        selectMethod = window.innerWidth > 1023 ? selectAddon2 : setAddon
        break;
      default:
        break;
    }
  })

  const isAdded = () => {
    if (step == 1)
      return data.optionIndex == optionIndex
    else if (step == 2)
      return data.optionIndex == material
    else if (step < 5)
      return addons.filter((addon) => addon.productId === data.productId && addon.variantId === data.variantId).length
  }
  const isSelected = () => {
    if (step == 1)
      return data.optionIndex == optionIndex
    else if (step == 2)
      return data.optionIndex == optionIndex
    else if (step == 3)
      return addonSeleted && addonSeleted.productId === data.productId && addonSeleted.variantId === data.variantId
    else if (step == 4)
      return addon2Seleted && addon2Seleted.productId === data.productId && addon2Seleted.variantId === data.variantId
  }

  console.log(activeProduct)

  return (

    <div className={`min-w-[165px] lg:w-full h-[250px] relative bg-puffco-grey-5 border border-puffco-grey-5 px-4 py-4 lg:py-9 overflow-hidden cursor-pointer
     ${isSelected() || isAdded() ? 'lg:border lg:border-black' : ''}  ${color === 1 && displayName == 'Proxy Kit - Black' ? 'hidden cls' : ''}
     ${color === 0 && displayName == 'Proxy Kit - Desert' ? 'hidden cls' : ''}
     `}

      onClick={() => dispatch(selectMethod(step < 3 ? data.optionIndex : { productId: data.productId, variantId: data.variantId }))}>
      {optionImage ?
        <img className='h-full w-3/5 lg:w-full mx-auto object-contain' src={optionImage.replace('.jpg?', '.jpg?width=250&').replace('.png?', '.png?width=250&').replace('.webp?', '.webp?width=250&')} />
        : null
      }

      <div className='top-6 left-4 absolute tracking-[2px] text-black font-bold text-xs leading-[120%]'>{displayName}</div>
      {data.option && data.option.sash || activeProduct && activeProduct.metafields.sash || activeVariant && activeVariant.metafields.sash
        ? <span className='bg-black absolute right-0 top-0 text-[0.75rem] px-5 pt-1 pb-[0.35rem] absolute top-0 right-0 text-white text-[8px] leading-none'>
            {data.option && data.option.sash === 'New' || activeProduct && activeProduct.metafields.sash === 'New' || activeVariant && activeVariant.metafields.sash === 'New' ? <>New</> : null}
            {data.option && data.option.sash === 'Best Seller' || activeProduct && activeProduct.metafields.sash === 'Best Seller' || activeVariant && activeVariant.metafields.sash === 'New' ? <>Best Seller</> || activeVariant && activeVariant.metafields.sash === 'None' : null}
          </span>
        : null
      }
      {
        isAdded() ?
          <button className={`bg-black rounded-md px-4 h-[2.125rem] ${step == 1 ? 'inline-flex lg:hidden' : 'inline-flex'} items-center justify-center absolute left-4 right-4 bottom-3 lg:bottom-4 text-white font-mono text-xs`} onClick={(e) => { e.stopPropagation(); step > 2 ? dispatch(setMethod({ productId: data.productId, variantId: data.variantId })) : null }}>
            <svg className="icon icon-checkmark fill-current mr-2.5" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 12 9" fill="none">
              <path fillRule="evenodd" clipRule="evenodd" d="M11.35.643a.5.5 0 01.006.707l-6.77 6.886a.5.5 0 01-.719-.006L.638 4.845a.5.5 0 11.724-.69l2.872 3.011 6.41-6.517a.5.5 0 01.707-.006h-.001z" fill="currentColor" />
            </svg>
            {step == 1 || step == 2 ? 'SELECTED' : 'ADDED'}
          </button> :
          <button className={`border border-black text-xs hover:bg-black hover:text-white rounded-md ${step == 1 ? 'inline-flex lg:hidden' : 'inline-flex'} items-center justify-center px-4 h-[2.125rem] absolute bottom-3 lg:bottom-4 left-4 right-4 font-mono`} onClick={(e) => { e.stopPropagation(); dispatch(setMethod(step < 3 ? data.optionIndex : { productId: data.productId, variantId: data.variantId })) }}>
            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" className="icon icon-plus fill-current mr-3" fill="none" viewBox="0 0 10 10" width="14" height="14">
              <path fillRule="evenodd" clipRule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor" />
            </svg>    {step === 1 ? 'SELECT' : '$' + parseFloat(listPrice).toLocaleString(undefined, { minimumFractionDigits: 2 }).replace('.00', '')}
          </button>
      }
    </div>
  )
}

export default ProductTile
